<template>
  <div class="wrapper">
    <!-- 首次登录时设置密码 or 忘记密码时重置密码 -->
    <div class="title">
      {{ type === 'SET' ? $t('首次登录，请设置网银登录密码') : `${$t('重置登录密码')}（3/3）` }}
    </div>
    <div class="text">{{ $t('新密码 (长度6-12位)') }}</div>
    <FormInput
      ref="pwdInput"
      class="input"
      style="margin-bottom: 15px;"
      v-model="pwdInfo.value"
      :type="pwdInfo.inputType"
      :placeholder="$t('输入数字、字母或数字字母组合，区分大小写')"
      :reg-exp="/[^0-9a-zA-Z]/g"
      :max-length="12"
      :input-disabled="false"
      :encrypted="appInfo.APP_KEYCODE_CONTROL_ENABLED"
      @blur="handlePwdBlur">
      <div
        slot="right"
        class="input-control"
        v-show="pwdInfo.value">
        <AliIcon
          v-show="!pwdInfo.visible"
          name="biyan"
          @click="handlePwdInfoVisble(true)">
        </AliIcon>
        <AliIcon
          v-show="pwdInfo.visible"
          name="zhengyan"
          @click="handlePwdInfoVisble(false)">
        </AliIcon>
      </div>
    </FormInput>
    <FormInput
      ref="pwdAgainInput"
      class="input"
      style="margin-bottom: 8px;"
      v-model="pwdAgainInfo.value"
      :type="pwdAgainInfo.inputType"
      :placeholder="$t('请再次输入新密码')"
      :reg-exp="/[^0-9a-zA-Z]/g"
      :max-length="12"
      :input-disabled="false"
      :encrypted="appInfo.APP_KEYCODE_CONTROL_ENABLED"
      @blur="handlePwdAgainBlur">
      <div
        slot="right"
        class="input-control"
        v-show="pwdAgainInfo.value">
        <AliIcon
          v-show="!pwdAgainInfo.visible"
          name="biyan"
          @click="handlePwdAgainInfoVisble(true)">
        </AliIcon>
        <AliIcon
          v-show="pwdAgainInfo.visible"
          name="zhengyan"
          @click="handlePwdAgainInfoVisble(false)">
        </AliIcon>
      </div>
    </FormInput>
    <div class="login-tip">
      {{ $t('企业网银登录，可以在验证码或网银登录密码两种登录方式中任选一种，请牢记您的网银登录密码') }}
    </div>
    <el-button
      class="confirm-btn"
      type="primary"
      :disabled="confirmDisabled"
      @click="handleConfirm">
      {{ $t('确定') }}
    </el-button>
    <BackButton
      @click="handleBack"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { ajax } from '@/utils/http/ajax'
import httpBaseUrl from '@/utils/http/base-url'
import loginApi from '@/api/login'
// 密码控件
import ctrl from '@/utils/plugins/PassGuardCtrl'
import { getSignDataByObj } from '@/utils/USBKeyUtil'
const { pge: Pge, pgeInit } = ctrl
export default {
  props: {
    type: {
      type: String,
      default: 'SET'
    }
  },
  data () {
    return {
      pgeCtrl1: null,
      pgeCtrl2: null,
      // 密码加密因子
      srandNum: '',
      // 密码私钥
      uuid: '',
      /* 新密码 */
      pwdInfo: {
        value: '',
        inputType: 'password',
        visible: false
      },
      /* 再次新密码 */
      pwdAgainInfo: {
        value: '',
        inputType: 'password',
        visible: false
      }
    }
  },
  computed: {
    ...mapState('app', ['appInfo']),
    ...mapState('login', ['faceSession', 'userInfo']),
    confirmDisabled () {
      const { APP_KEYCODE_CONTROL_ENABLED } = this.appInfo
      if (APP_KEYCODE_CONTROL_ENABLED) {
        return false
      } else if (!APP_KEYCODE_CONTROL_ENABLED && this.pwdInfo.value && this.pwdAgainInfo.value) {
        return false
      }
      return true
    }
  },
  created () {
    this.getSrandNum()
  },
  mounted () {
    if (this.appInfo.APP_KEYCODE_CONTROL_ENABLED) {
      // 这里之所以加setTimeout 是因为登录密码的组件使用的v-show 也就是说页面刷新时 会同时有两套密码控件初始化 导致全局的window.pgeCtrl会有冲突 所以暂时改成异步延时器 根本的解决办法在于修复登录页面的控件初始化时机
      setTimeout(() => {
        this.handleInitKeyCode()
      }, 500)
    }
  },
  methods: {
    ...mapMutations('login', ['SET_LOGIN_STATE', 'SET_RESET_STATE', 'RESET_LOGIN_STATE']),
    // 获取加密因子
    getSrandNum () {
      return loginApi.getSrandNum({
        channel: '1103',
        responseFormat: 'JSON'
      }).then(res => {
        if (res) {
          const { srandNum, uuid } = res
          this.srandNum = srandNum
          this.uuid = uuid
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 密码控件初始化
    handleInitKeyCode () {
      // 密码登录输入框
      const pwdInput = this.$refs.pwdInput.$refs.inputWrapper
      const pwdAgainInput = this.$refs.pwdAgainInput.$refs.inputWrapper
      // 请求通讯加密两个参数(随机数pgeRZRandNum和数据B pgeRZDataB)
      ajax.request({
        url: `${process.env.BASE_URL}${httpBaseUrl.NO_PREFIX_URL}/SkeyAndeEnstr`,
        type: 'GET',
        async: false,
        success: (response) => {
          const targetStr = '(' + response.responseText + ')'
          // eslint-disable-next-line
          const retJson = eval(targetStr)
          const random = retJson.sKey
          const datab = retJson.enStr
          const nowTime = new Date().getTime()
          // 初始化实例前 要重置下pges数组
          window.pges = []
          this.pgeCtrl1 = window.pgeCtrl = new Pge({
            pgePath: './ocx/', // 控件下载目录，可以指定绝对路径，如"http://www.baidu.com/download/"
            pgeId: '_ocx_password1', // 控件id
            pgeEditType: 0, // 控件显示类型,0(星号),1(明文)
            pgeEreg1: '', // 输入过程中字符类型限制，如"[0-9]*"表示只能输入数字
            pgeEreg2: '^[0-9a-zA-Z]{6,12}$', // 输入完毕后字符类型判断条件，与pgeditor.pwdValid()方法对应
            pgeMaxLength: 12, // 允许最大输入长度
            pgeTabIndex: 1, // tab键顺序
            pgeClass: 'ocx_style', // 控件css样式
            pgeInstallClass: 'ocx_style_init', // 针对安装或升级的css样式
            tabCallBack: '_ocx_password2', // 火狐tab键回调函数,设置要跳转到的对象ID
            pgeWindowID: 'password' + nowTime + 30,
            pgeRZRandNum: random,
            pgeRZDataB: datab,
            placeholder: '新密码/New password'
          })
          this.pgeCtrl2 = window.pgeCtrl = new Pge({
            pgePath: './ocx/', // TODO:控件下载目录，可以指定绝对路径，如"http://www.baidu.com/download/"
            pgeId: '_ocx_password2', // 控件id
            pgeEditType: 0, // 控件显示类型,0(星号),1(明文)
            pgeEreg1: '', // 输入过程中字符类型限制，如"[0-9]*"表示只能输入数字
            pgeEreg2: '^[0-9a-zA-Z]{6,12}$', // 输入完毕后字符类型判断条件，与pgeditor.pwdValid()方法对应
            pgeMaxLength: 12, // 允许最大输入长度
            pgeTabIndex: 2, // tab键顺序
            pgeClass: 'ocx_style', // 控件css样式
            pgeInstallClass: 'ocx_style_init', // 针对安装或升级的css样式
            tabCallBack: '_ocx_password1', // 火狐tab键回调函数,设置要跳转到的对象ID
            pgeWindowID: 'password' + nowTime + 40,
            pgeRZRandNum: random,
            pgeRZDataB: datab,
            placeholder: '确认密码/Confirm password'
          })
          // 绘制控件标签
          this.pgeCtrl1.pwdhtml(pwdInput, this.pgeCtrl1.load())
          this.pgeCtrl2.pwdhtml(pwdAgainInput, this.pgeCtrl2.load())
          // 初始化
          pgeInit()
        }
      })
    },
    // 获取密码
    getPassword (pgeCtrl, password) {
      const { APP_KEYCODE_CONTROL_ENABLED } = this.appInfo
      if (APP_KEYCODE_CONTROL_ENABLED) {
        const length = pgeCtrl.pwdLength()
        if (length === '0' || !length) {
          this.$talert('密码不能为空')
          return
        }
        if (String(pgeCtrl.pwdValid()) === '1') {
          this.$talert('登录密码格式错误，请正确输入6-12位数字或字母组合密码')
          return
        }
        // 获取加密的密码
        pgeCtrl.pwdSetSk(this.srandNum)
        const passwordEncrypted = pgeCtrl.pwdResult()
        return passwordEncrypted
      } else {
        return password
      }
    },
    /* 新密码 */
    handlePwdInfoVisble (boolean) {
      if (boolean) {
        // 睁眼
        this.pwdInfo.inputType = 'text'
      } else {
        // 闭眼
        this.pwdInfo.inputType = 'password'
      }
      this.pwdInfo.visible = boolean
    },
    handlePwdBlur () {
      // 判断密码长度是否在6-12位之间
      const { value } = this.pwdInfo
      const length = value && value.length
      if (!length) return
      if (!(length >= 6 && length <= 12)) {
        this.$warn('密码长度在6-12位之间')
        this.pwdInfo.value = ''
        // this.$refs.pwdInput.$refs.input.focus()
      }
    },
    /* 再次输入新密码 */
    handlePwdAgainInfoVisble (boolean) {
      if (boolean) {
        // 睁眼
        this.pwdAgainInfo.inputType = 'text'
      } else {
        // 闭眼
        this.pwdAgainInfo.inputType = 'password'
      }
      this.pwdAgainInfo.visible = boolean
    },
    handlePwdAgainBlur () {
      // 判断密码长度是否在6-12位之间
      const { value } = this.pwdAgainInfo
      const length = value && value.length
      if (!length) return
      if (!(length >= 6 && length <= 12)) {
        this.$warn('密码长度在6-12位之间')
        this.pwdAgainInfo.value = ''
        // this.$refs.pwdAgainInput.$refs.input.focus()
      }
    },
    // 清除表单信息
    clearFormData () {
      if (this.appInfo.APP_KEYCODE_CONTROL_ENABLED) {
        this.pgeCtrl1.pwdClear()
        this.pgeCtrl2.pwdClear()
      } else {
        // 密码
        this.pwdInfo.value = ''
        this.pwdAgainInfo.value = ''
      }
    },
    // 确定
    handleConfirm () {
      const password = this.getPassword(this.pgeCtrl1, this.pwdInfo.value)
      const confirmPassword = this.getPassword(this.pgeCtrl2, this.pwdAgainInfo.value)
      if (!password || !confirmPassword) {
        this.clearFormData()
        return
      }
      if (password !== confirmPassword) {
        this.$warn('两次密码输入不一致，请重新输入')
        this.clearFormData()
        return
      }
      const { type, uuid: sranNum, faceSession } = this
      if (type === 'SET') {
        // 设置密码
        loginApi.setPassword({
          password,
          confirmPassword,
          sranNum
        }).then(res => {
          if (res) {
            // 重置表单
            this.clearFormData()
            // 重置登录态
            this.RESET_LOGIN_STATE()
            // 提示  添加window.location.reload是因为登录密码的密码控件受到重置密码的密码控件影响了
            this.$talert('网银登录密码设置成功，请重新登录', '系统提示').then(() => {
              window.location.reload()
            }).catch(_ => {
              window.location.reload()
            })
          }
        }).catch(err => {
          console.error(err)
        })
      } else if (type === 'RESET') {
        // const { APP_SIGNDATA_ENABLED } = this.appInfo
        const { customerId: cstId, userId } = this.userInfo
        const transferName = '重置密码'
        const info = {
          obviousInfo: {
            交易名称: transferName,
            网银客户号: cstId,
            用户号: userId
          },
          hiddenInfo: {
            password,
            transactionCode: '00000000'
          }
        }
        getSignDataByObj.call(this, info, signData => {
          loginApi.resetPassword({
            cstId,
            userId,
            sranNum,
            password,
            faceSession,
            signData,
            transferName
          }).then(res => {
            if (res) {
              // 设置成功 重新登录
              this.SET_LOGIN_STATE('page-form')
              this.$success('成功')
              // 重置登录密码
              this.SET_RESET_STATE('stepOne')
            }
          }).catch(err => {
            console.error(err)
          })
        })
      }
    },
    handleBack () {
      const { type } = this
      if (type === 'SET') {
        // 设置密码
        this.SET_LOGIN_STATE('page-form')
      } else {
        // 重置密码
        this.SET_RESET_STATE('stepTwo')
      }
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  padding: 62px 34px 0;
  text-align: left;
  .title {
    text-align: left;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #131523;
    line-height: 20px;
    user-select: none;
  }
  .text {
    margin: 35px 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333752;
    line-height: 14px;
    user-select: none;
  }
  .input {
    width: 100%;
    height: 46px;
    line-height: 46px;
    text-align: left;
  }
  .input-control {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
  }
  .login-tip {
    margin-bottom: 60px;
    font-size: 12px;
    font-weight: 400;
    color: #A1A7C4;
    line-height: 18px;
    user-select: none;
  }
  .confirm-btn {
    width: 100%;
    height: 46px;
  }
}
</style>
